// extracted by mini-css-extract-plugin
module.exports = {"footerBtm":"footer_footerBtm__2pEX3","desktopFooter":"footer_desktopFooter__MNnTS"};